import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { generateMerkleProof } from '../../whitelist/merkle-tree'
import { connect } from '../../redux/blockchain/blockchainActions'
import { fetchData } from '../../redux/data/dataActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const Info = () => {
  const [feedback, setFeedback] = useState(`Hit the buttons!`)

  const dispatch = useDispatch()
  const blockchain = useSelector((state) => state.blockchain)
  const data = useSelector((state) => state.data)
  const [claimingNft, setClaimingNft] = useState(false)
  const [mintAmount, setMintAmount] = useState(1)
  const [CONFIG, SET_CONFIG] = useState({
    NFTNAME: "SIGNATURE",
    CONTRACT_ADDRESS: "0x0000000000000000000000000000000000000000",
    NETWORK: "Ethereum",
    ID: 1,
    MARKETPLACE: "Opeansea",
    TWITTER: "https://twitter.com/",
    ETHERSCAN: "https://etherscan.io/",
    DISCORD: "https://discord.com/",
    MARKETPLACE_LINK: "https://opensea.io/"
  })
  var loaderTxt = ``;
  var supplyLimit;
  var price;
  var MintCount;
  var maxLimitPerWallet;
  var maxMintAmountPerTx;
  var saleStatus;
  var sale;
  var button;

  const getData = () => {
		if (blockchain.account !== '' && blockchain.smartContract !== null) {
			dispatch(fetchData(blockchain.account))
		}
	}

	useEffect(() => {
		getData((data.totalSupply))
	}, [blockchain.account])

	const getConfig = async () => {
		const configResponse = await fetch('/config/config.json', {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		})
		const config = await configResponse.json()
		SET_CONFIG(config)
	}

	useEffect(() => {
		getConfig()
	}, [])

	const decrementMintAmount = () => {
		let newMintAmount = mintAmount - 1
		if (newMintAmount < 1) {
			newMintAmount = 1
		}
		setMintAmount(newMintAmount)
	}

	const minMintAmount = () => {
		let newMintAmount = 1
		setMintAmount(newMintAmount)
	} 
  
	const maxMintAmount = () => {
		let newMintAmount = maxMintAmountPerTx
		setMintAmount(newMintAmount)
	}  

	const incrementMintAmount = () => {
		let newMintAmount = mintAmount + 1
		if (newMintAmount > maxMintAmountPerTx) {
			newMintAmount = maxMintAmountPerTx
		}
		setMintAmount(newMintAmount)
	}

	if ((data.wlsaleStatus) == true) {
		supplyLimit = (data.wlsupplyLimit);
		price = (data.wlprice);
		MintCount = (data.wlMintCount);
		maxLimitPerWallet = (data.wlmaxLimitPerWallet);
		maxMintAmountPerTx = (data.wlmaxMintAmountPerTx);
		saleStatus = (data.wlsaleStatus);
    sale = "Whitelist";
	}
	else {
		supplyLimit = (data.publicsupplyLimit);
		price = (data.publicprice);
		MintCount = (data.publicMintCount);
		maxLimitPerWallet = (data.publicmaxLimitPerWallet);
		maxMintAmountPerTx = (data.publicmaxMintAmountPerTx);
		saleStatus = (data.publicSaleStatus);
    sale = " Public";
	}

	const genProof = () => {
		var address = document.getElementById("address").value;
		const merkleProof = generateMerkleProof(address).toString();
		console.log(merkleProof)
		if (merkleProof.length < 1) {
			setFeedback(`You are not whitelisted!`)
		}
		else {
			navigator.clipboard.writeText(merkleProof);
			setFeedback(`Copied!`)
		}
	}
	const WlclaimNFTs = () => {
		let cost = (data.wlprice)
		let totalCostWei = String((data.wlprice) * mintAmount)
		console.log('Cost: ', totalCostWei)
		console.log(cost)
		setFeedback(`Minting your ${CONFIG.NFT_NAME}...`)
		setClaimingNft(true)
		const merkleProof = generateMerkleProof(blockchain.account);
		blockchain.smartContract.methods
			.WlMint(mintAmount, merkleProof)
			.send({
				gasLimit: 210000,
				maxPriorityFeePerGas: null,
				maxFeePerGas: null,
				to: CONFIG.CONTRACT_ADDRESS,
				from: blockchain.account,
				value: totalCostWei,
			})
			.once('error', (err) => {
				console.log(err)
				setFeedback(err.message)
				setClaimingNft(false)
			})
			.then((receipt) => {
				console.log(receipt)
				setFeedback(
					`The ${CONFIG.NFTNAME} is yours! go visit ${CONFIG.MARKETPLACE} to view it.`,
				)
				setClaimingNft(false)
				dispatch(fetchData(blockchain.account))
			})
	}

	const PublicclaimNFTs = () => {
		let cost = (data.publicprice)
		let totalCostWei = String(cost * mintAmount)
		console.log('Cost: ', totalCostWei)
		console.log(cost)
		setFeedback(`Minting your ${CONFIG.NFTNAME}...`)
		setClaimingNft(true)
		blockchain.smartContract.methods
			.PublicMint(mintAmount)
			.send({
				gasLimit: 210000,
				maxPriorityFeePerGas: null,
				maxFeePerGas: null,
				to: CONFIG.CONTRACT_ADDRESS,
				from: blockchain.account,
				value: totalCostWei,
			})
			.once('error', (err) => {
				console.log(err)
				setFeedback(err.message)
				setClaimingNft(false)
			})
			.then((receipt) => {
				console.log(receipt)
				setFeedback(
					`The ${CONFIG.NFTNAME} is yours! go visit ${CONFIG.MARKETPLACE} to view it.`,
				)
				setClaimingNft(false)
				dispatch(fetchData(blockchain.account))
			})
	}

	if ((data.maxSupply) == 1 && blockchain.smartContract !== null) {
		loaderTxt = <React.Fragment>
			{'Loading please wait'} {" "}
			<FontAwesomeIcon icon={faSpinner} />
		</React.Fragment>
	}

	if (Number(data.totalSupply) >= Number(data.maxSupply)) {
		button = <React.Fragment>
			<a href={CONFIG.MARKETPLACE_LINK} target={'_blank'}> <button className="buy">
				
				Soldout! Checkout {CONFIG.MARKETPLACE}
			</button> </a>
		</React.Fragment>
	}
	else if ((data.wlsaleStatus) == true) {
		button = <React.Fragment>
			<button className="buy"
				disabled={claimingNft ? 1 : 0}
				onClick={(e) => {
					if ((data.wlsaleStatus) == true) {
						if (Number(data.wlMinted) + mintAmount <= Number(data.wlsupplyLimit)) {
							const merkleProof = generateMerkleProof(blockchain.account);
							if (merkleProof.length > 0) {
								if (((Number(data.wlMintCount)) + Number(mintAmount)) <= (Number(data.wlmaxLimitPerWallet))) {
									WlclaimNFTs()
								}
								else {
									setFeedback('Max Mint Limit Reached or Minting more than allowed!')
								}
							}
							setFeedback('Not whitelisted!')
						}
						else {
							setFeedback('Whitelist Supply Soldout!')
						}
					}
					else {
						setFeedback('Sale Not Active!')
					}
					getData()
				}}
			>
				
				{claimingNft ? 'BUSY' : 'Whitelist Mint'}
			</button>
		</React.Fragment>
	}
	else {
		button = <React.Fragment>
			<button
				disabled={claimingNft ? 1 : 0}
				onClick={(e) => {
					if ((data.publicSaleStatus) == true) {
						if (Number(data.publicMinted) + mintAmount <= Number(data.publicsupplyLimit)) {

							if (((Number(data.publicMintCount)) + Number(mintAmount)) <= (Number(data.publicmaxLimitPerWallet))) {
								PublicclaimNFTs()
							}
							else {
								setFeedback('Max Mint Limit Reached or Minting more than allowed!')
							}
						}
						else {
							setFeedback('Public Supply Reached')
						}
					}
					else {
						setFeedback('Sale Not Active')
					}
					getData()
				}}
				className="buy">
				
				{claimingNft ? 'BUSY' : 'Mint'}
			</button>
		</React.Fragment>
	}  


  const shoeName = (
    <div className="shoeName">
      <div>
        <h1 className="big">ReservedSnow Minting Dapp</h1>
        <span className="new">{sale}</span>
      </div>
      <h3 className="small">MINT YOUR {CONFIG.NFTNAME} NFTS!</h3>
    </div>
  );

  const description = (
    <div className="description">
      <h3 className="title">Description</h3>
      <p className="text">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.

      </p>
    </div>
  );

  const ColorContainer = (
    <div className="color-container">
      <div className="colors">
        <span className="color active" primary="#2175f5" color="blue"></span>
        <span className="color" primary="#f84848" color="red"></span>
        <span className="color" primary="#29b864" color="green"></span>
        <span className="color" primary="#ff5521" color="orange"></span>
        <span className="color" primary="#444" color="black"></span>
      </div>
    </div>
  );

  const SizeContainer = (
    <div className="size-container">
      <h3 className="title"> Amount: {mintAmount}</h3>
      <div className="sizes">
        <span className="size" onClick={(e) => {
									e.preventDefault()
									minMintAmount()
								}}>min</span>
        <span className="size" disabled={claimingNft ? 1 : 0}
								onClick={(e) => {
									e.preventDefault()
									decrementMintAmount()
								}}>-1</span>
        <span className="size" disabled={claimingNft ? 1 : 0}
								onClick={(e) => {
									e.preventDefault()
									incrementMintAmount()
								}}>+1</span>
        <span className="size active" onClick={(e) => {
									e.preventDefault()
									maxMintAmount()
								}}>max</span>
      </div>
    </div>
  );

  const feedbackDesc = (
    <div className="description">
      <p className="text">
        {feedback} {loaderTxt}
      </p>
    </div>
  );  

  const BuySection = (
    <div className="buy-price">
      					{blockchain.account === '' ||
						blockchain.smartContract === null ? (<button onClick={(e) => {
							e.preventDefault()
							dispatch(connect())
							getData()
						}} className="buy">
							
							Connect
						</button>) : (<>
							{button}
						</>)}
      <div className="price">
        <h1>Ξ{price / 1e18}</h1>
      </div>
    </div>
  );

  return (
    <div className="info">
      {shoeName}
      {description}
      {ColorContainer}
      {SizeContainer}
      {feedbackDesc}
      {BuySection}
    </div>
  );
};

export default Info;
